import Constants from '@/Constants';
import Category from '@/models/Category';
import { ApplicationState } from '@/store';
import { useSelector } from 'react-redux';
import { useGetPaginated } from './useGetPaginated';

interface Props {
    familyId?: number;
    limit?: number;
}

const DEFAULT_CATEGORY_LIMIT = 100;

const useCategories = ({ familyId, limit = DEFAULT_CATEGORY_LIMIT }: Props) => {
    const applicationId = useSelector((state: ApplicationState) => state.identity.data.user.applicationId);
    const organizationId = useSelector((state: ApplicationState) => state.identity.data.user.orgId);

    const { data: categories, loading, total } = useGetPaginated<Category>((index: number) => {
        const offset: number = index * limit;

        const queryParams: string = Object.entries({ offset, limit, applicationId, organizationId, familyId })
            .filter(([, value]) => value !== undefined)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        return `${Constants.CATEGORIES_URI}?${queryParams}`;
    });

    return { categories, loading, total };
};

export default useCategories;
